import logo from "./EvergreenLogo.png";
import person from "./person-circle.svg";
import { Dropdown, Nav, Navbar } from "react-bootstrap";
import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "shared/i18n/useTranslation";
import { useUser } from "shared/auth/user/context";
import "./style.module.css";
// @ts-ignore
const CustomToggle = React.forwardRef(({ onClick }, ref) => (
  <div
    role="button"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <div className="d-md-none mx-2 nav-link">Profile</div>
    <img
      role="button"
      className="mx-3 pointer d-none d-md-block"
      width={"31px"}
      src={person}
      alt="profile"
    />
  </div>
));

export function Header() {
  const { translate } = useTranslation();
  const { hasRole, isLoggedIn } = useUser();
  return (
    <Navbar collapseOnSelect expand="md" bg="white" variant="light">
      <Navbar.Brand className="mx-2" as={Link} to="/">
        <img
          src={logo}
          className="d-inline-block align-top"
          alt={translate("__logo")}
          height="70px"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" className="mx-2" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <>
          <Nav className="me-auto mx-2">
            {hasRole("Administrator") && (
              <>
                <Nav.Link as={NavLink} to="/site/survey/list">
                  Surveys
                </Nav.Link>
                <Nav.Link as={NavLink} to="/site/survey/edit">
                  {translate("_addSurvey")}
                </Nav.Link>
              </>
            )}
          </Nav>

          <Nav>
            <Dropdown align={{ md: "end" }}>
              <Dropdown.Toggle as={CustomToggle}></Dropdown.Toggle>
              <Dropdown.Menu>
                {!isLoggedIn() && (
                  <Dropdown.Item as={Link} to={"/login"}>
                    {translate("__login")}
                  </Dropdown.Item>
                )}
                {isLoggedIn() && (
                  <Dropdown.Item as={Link} to={"/logout"}>
                    {translate("__logout")}
                  </Dropdown.Item>
                )}
                {!isLoggedIn() && (
                  <Dropdown.Item as={Link} to={"/forgotPassword"}>
                    {translate("__forgotPassword?")}
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </>
      </Navbar.Collapse>
    </Navbar>
  );
}
